import { ShieldCheck, ShieldX } from 'lucide-react';

const PlagiarismCheck = ({
  isPlagiarismCheckPassed
}: {
  isPlagiarismCheckPassed: boolean;
}) => {
  return (
    <div
      className={`flex items-center space-x-1.5 rounded-full px-3 py-1 text-sm font-medium ${
        isPlagiarismCheckPassed
          ? 'bg-emerald-50 text-emerald-700'
          : 'bg-red-50 text-red-700'
      }`}
    >
      {isPlagiarismCheckPassed ? (
        <ShieldCheck className='h-4 w-4' />
      ) : (
        <ShieldX className='h-4 w-4' />
      )}
      <span>
        {isPlagiarismCheckPassed
          ? 'Plagiarism Check Passed'
          : 'Plagiarism Detected'}
      </span>
    </div>
  );
};

export default PlagiarismCheck;
